'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsFetching, useQueryClient, type QueryKey } from '@tanstack/react-query';

/**
 * Wires a React Query key to refresh helpers for section headers and action bars.
 * `isRefreshing` tracks in-flight fetches for the key; `refresh` invalidates it.
 */
export function useQueryRefresh(queryKey) {
  const $ = _c(8);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryKey) {
    t0 = {
      queryKey
    };
    $[0] = queryKey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isRefreshing = useIsFetching(t0) > 0;
  let t1;
  if ($[2] !== queryClient || $[3] !== queryKey) {
    t1 = () => queryClient.invalidateQueries({
      queryKey
    });
    $[2] = queryClient;
    $[3] = queryKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const refresh = t1;
  let t2;
  if ($[5] !== isRefreshing || $[6] !== refresh) {
    t2 = {
      isRefreshing,
      refresh
    };
    $[5] = isRefreshing;
    $[6] = refresh;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}